import emptyClaimState from './svg/empty_state_claim.svg'
import emptyClaimStateNoResults from './svg/empty_state_claims_no_results.svg'
import emptyState from './svg/empty_state.svg'
import redbit from './svg/redbit.svg'
import computer from './svg/404_computer.svg'
import multipleComputers from './svg/multiple_computer.svg'
import BenefitCard from './svg/example_benefit_card.png'
import EmptyStateProviders from './svg/empty-state-providers.js'

import IconDrug from './svg/Icon-Drug.js'
import IconDentist from './svg/Icon-Dentist'
import IconCalculator from './svg/Icon-Calculator'

export {
  IconDrug,
  IconDentist,
  IconCalculator,
  EmptyStateProviders,
  BenefitCard,
  computer,
  multipleComputers,
  redbit,
  emptyState,
  emptyClaimState,
  emptyClaimStateNoResults
}



// WEBPACK FOOTER //
// ./src/assets/images/index.js